module.exports = __webpack_public_path__ + "img/box-arrow-right.18a08fdb.svg";